import { ReactNode, useMemo } from 'react';

import { UserDto } from '~modules/user/model';

import { AuthContext } from '../../model';

interface AuthProviderProps {
	children: ReactNode;
	user: UserDto | null;
	isPending: boolean;
	error: boolean;
	logout: () => void;
}

export function AuthProvider({ children, user, isPending, error, logout }: AuthProviderProps) {
	const contextValue = useMemo(
		() => ({
			user,
			logout,
			isPending,
			error,
		}),
		[user, isPending, error, logout],
	);

	return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
}
